import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaShareAlt
} from 'react-icons/fa'

import styles from './styles.module.scss'

interface Props {
  description: string
  title: string
}

export const SocialShare: React.FC<Props> = ({ description, title }) => {
  const router = useRouter()
  const [isMobile, setIsMobile] = useState(false)
  const [hasNativeShare, setHasNativeShare] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768)
      setHasNativeShare(!!navigator.share)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const url = () => {
    const { protocol, hostname } = window.location
    return `${protocol}//${hostname}${router.asPath}`
  }

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: description,
          url: url()
        })
      } catch (error) {
        console.log('Erro ao compartilhar:', error)
      }
    }
  }

  const shareOnWhatsapp = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${title} ${url()} via Portal Solar`,
      '_blank'
    )
    return false
  }

  const shareOnFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${url()}`,
      'popup',
      'width=600,height=600,scrollbars=no,resizable=no'
    )
    return false
  }

  const shareOnTwitter = () => {
    // TODO: Pensar em colocar hashtags e marcar os autores pelos paramêtros hashtags e related
    // https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
    window.open(
      `https://twitter.com/intent/tweet?text=${description}&url=${url()}`,
      'popup',
      'width=600,height=600,scrollbars=no,resizable=no'
    )
    return false
  }

  const shareOnLinkedin = () => {
    window.open(
      `https://www.linkedin.com/shareArticle?mini=true&url=${url()}`,
      'popup',
      'width=600,height=600,scrollbars=no,resizable=no'
    )
    return false
  }

  // Exibe botão de compartilhamento nativo no mobile
  if (isMobile && hasNativeShare) {
    return (
      <div className={styles.socialShareContainer}>
        <button
          type="button"
          className="icon  share flex items-center px-6 py-2"
          onClick={handleNativeShare}
          aria-label="Compartilhar"
        >
          <FaShareAlt size={16} />
          <span className="text-sm ml-2">Compartilhar</span>
        </button>
      </div>
    )
  }

  // Exibe botões individuais no desktop ou quando não há suporte nativo
  return (
    <div className={styles.socialShareContainer}>
      <button type="button" className="icon whatsapp" onClick={shareOnWhatsapp}>
        <FaWhatsapp size={14} />
      </button>

      <button type="button" className="icon facebook" onClick={shareOnFacebook}>
        <FaFacebookF size={14} />
      </button>

      <button type="button" className="icon linkedin" onClick={shareOnLinkedin}>
        <FaLinkedinIn size={14} />
      </button>

      <button type="button" className="icon twitter" onClick={shareOnTwitter}>
        <FaTwitter size={14} />
      </button>
    </div>
  )
}
